import { Heading, Alert } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { TemplateManagementRoute } from 'sections/design/template-management/routes';
import styled from 'styled-components';
import { useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { NameBarElement, NameBarElementItem } from './style';

const CentreAlert = styled.div`
  width: 50%;
  margin: 15% auto 0 auto;
`;

export const TemplateEditorDone = () => {
  const state = useTemplateEditorState();
  const { t } = useTranslation('designs');

  return (
    <>
      <NameBarElement data-testid="TemplateNameBar">
        <NameBarElementItem>
          <Heading variation="h4">{state.template.templateName}</Heading>
        </NameBarElementItem>
      </NameBarElement>
      <CentreAlert>
        <Alert variation="success" heading={t('designGallery.templateEditor.editFinished.title')}>
          {t('designGallery.templateEditor.editFinished.description')}
          <hr />
          <Link to={generatePath(TemplateManagementRoute.HOME, { siteId: state.site.id, channel: 'email' })}>
            « {t('designGallery.templateEditor.editFinished.linkBackText')}
          </Link>
        </Alert>
      </CentreAlert>
    </>
  );
};
